!function(e){"use strict";"function"==typeof define&&define.amd?define("jquery/ui-modules/jquery-var-for-color",["jquery","jquery-ui-modules/version"],e):e(jQuery)}((function(){"use strict"}));
